import { render, staticRenderFns } from "./CampoComplejidadProyecto.vue?vue&type=template&id=4f6cad8d"
import script from "./CampoComplejidadProyecto.vue?vue&type=script&lang=js"
export * from "./CampoComplejidadProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports